var _ellipse, _path, _path2, _ellipse2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-78 23.001 8)",
    fill: "#55ACEE",
    cx: 23,
    cy: 8,
    rx: 8,
    ry: 6.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#269",
    d: "M9.724 14.687v1.579c-2.414.525-5.381 1.851-5.829 3.741C2.493 25.919 2.87 35.081 2.87 35.212v.134c0 .654.663.654 1.316.654h16.097c.653 0 1.315 0 1.315-.654V20.007c0-1.719-1.413-3.438-4.632-3.834v-1.486H9.724z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#55ACEE",
    d: "M26.276 13.303v2.963c2.414.525 5.381 1.851 5.829 3.741 1.401 5.913 1.025 15.075 1.025 15.205v.134c0 .654-.663.654-1.316.654H15.717c-.653 0-1.315 0-1.315-.654V20.007c0-1.719 1.413-3.438 4.632-3.834v-1.486l7.242-1.384z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-12 12.992 8)",
    fill: "#269",
    cx: 12.992,
    cy: 8,
    rx: 6.75,
    ry: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#55ACEE",
    d: "M19.092 16.088c-1.31.381-3.441.546-5.898-.382-2.593-.98-4.978-1.944-5.908-2.268-.846-.295-3.005-.033-3.486.848-.481.881-.753 2.485.437 3.659s7.458 3.491 9.23 4.533c.928.546.874 3.823.928 6.499.083 4.043 7.383-13.67 4.697-12.889z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#269",
    d: "M12.233 25.283c1.331.298 3.604.811 5.999-.269 2.527-1.14 4.712-2.732 5.619-3.113.826-.347 2.571-.683 3.532.629.594.81.907 2.434-.207 3.679-1.115 1.246-5.497 3.919-8.739 4.702-2.749.664-6.967.6-8.313-.793-2.101-2.175.281-5.245 2.109-4.835zm12.758-8.048c0-1.952 1.724-3.016 3.739-3.797.835-.324 3.005-.033 3.486.848.481.881.753 2.485-.437 3.659s-6.788 2.294-6.788-.71z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHug);
export default __webpack_public_path__ + "static/media/hug.af0762ae57323b1c2ea2b382a4a2cca5.svg";
export { ForwardRef as ReactComponent };